<template>
  <div>
    <h1>PCWs</h1>
    <v-expansion-panel v-model="panel" expand>
      <v-expansion-panel-content>
        <template v-slot:header>
          <h2>
            <v-icon>search</v-icon>Search pcw database
          </h2>
        </template>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field v-model="reference" label="Reference" outline />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field v-model="surname" label="Surname" outline />
                </v-flex>
              </v-layout>
            </v-container>
            <v-btn @click="searchPcws" :loading="loading">
              <v-icon>search</v-icon>
              <span>&#160;Search</span>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-data-table
      :pagination.sync="pagination"
      :loading="loading"
      :headers="headers"
      :items="pcws"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn :to="{name:'pcw', params:{id: props.item.pcwId}}">{{ props.item.pcwId }}</v-btn>
          </td>
          <td>{{ props.item.oldId }}</td>
          <td>{{ props.item.client }}</td>
          <td>{{ props.item.matter }}</td>
          <td>{{ props.item.categoryCode }}</td>
          <td>{{ props.item.feeEarnerCode }}</td>
          <td>{{ props.item.completionDate | formatDate }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Pcws",
  metaInfo() {
    return {
      title: "Pcws",
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      pcws: [],
      reference: "",
      surname: "",
      panel: [],
      loading: false,
      headers: [
        {
          text: "Edit",
          value: "pcwId"
        },
        {
          text: "Reference",
          value: "oldId"
        },
        {
          text: "Surname",
          value: "client"
        },
        {
          text: "Matter",
          value: "matter"
        },
        {
          text: "Category",
          value: "categoryCode"
        },
        {
          text: "Fee earner",
          value: "feeEarnerCode"
        },
        {
          text: "Completed",
          value: "completionDate"
        }
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: "pcwId",
        descending: true
      }
    };
  },
  methods: {
    searchPcws() {
      nbmlaw
        .get(`/cors/admin/file/pcws`, {
          params: { reference: this.reference, surname: this.surname }
        })
        .then(response => {
          // console.log(response.data);
          this.pcws = response.data;
          this.loading = false;
        });
    }
  }
};
</script>

<style>
</style>
